import { motion } from 'framer-motion';

import { BG_DARK, DANGER_RED } from '../constants';

const ROUTE_COLORS = ['#93FF18', '#2ECDFF', '#06B6D4', '#66BB6A', '#FFA726'];

interface ConnectionPulseProps {
  stable: boolean;
  color: string;
}

export function ConnectionPulse({ stable, color }: ConnectionPulseProps) {
  return (
    <div className='relative w-full overflow-hidden rounded-lg' style={{ backgroundColor: BG_DARK, height: stable ? 80 : 64 }}>
      <svg className='size-full' viewBox={stable ? '0 0 400 80' : '0 0 400 60'} preserveAspectRatio='none'>
        {stable ? (
          ROUTE_COLORS.map((routeColor, i) => {
            const yBase = 10 + i * 14;
            const yWobble = 2;
            const d = `M0,${yBase} Q50,${yBase - yWobble} 100,${yBase} Q150,${yBase + yWobble} 200,${yBase} Q250,${yBase - yWobble} 300,${yBase} Q350,${yBase + yWobble} 400,${yBase}`;
            return (
              <g key={i}>
                <path d={d} fill='none' stroke={routeColor} strokeWidth='1.5' strokeOpacity='0.15' />
                <circle r='3' fill={routeColor} opacity='0.9'>
                  <animateMotion dur={`${2.2 + i * 0.3}s`} begin={`${i * 0.4}s`} repeatCount='indefinite' path={d} />
                </circle>
                <circle r='6' fill={routeColor} opacity='0.2'>
                  <animateMotion dur={`${2.2 + i * 0.3}s`} begin={`${i * 0.4}s`} repeatCount='indefinite' path={d} />
                </circle>
                <path d={d} fill='none' stroke={routeColor} strokeWidth='1.8' strokeOpacity='0.6' />
              </g>
            );
          })
        ) : (
          <>
            <path d='M0,30 L40,30 L50,8 L60,52 L70,5 L80,55 L90,30 L120,30 L130,10 L135,50 L140,30 L160,30 L170,55 L180,5 L190,48 L200,12 L210,30 L250,30 L260,52 L270,8 L280,55 L290,5 L300,30 L340,30 L350,8 L360,52 L370,30 L400,30' fill='none' stroke={color} strokeWidth='2' strokeOpacity='0.3' />
            <circle r='4' fill={color} opacity='0.9'>
              <animateMotion dur='3s' repeatCount='indefinite' path='M0,30 L40,30 L50,8 L60,52 L70,5 L80,55 L90,30 L120,30 L130,10 L135,50 L140,30 L160,30 L170,55 L180,5 L190,48 L200,12 L210,30 L250,30 L260,52 L270,8 L280,55 L290,5 L300,30 L340,30 L350,8 L360,52 L370,30 L400,30' />
            </circle>
            <motion.path d='M0,30 L40,30 L50,8 L60,52 L70,5 L80,55 L90,30 L120,30 L130,10 L135,50 L140,30 L160,30 L170,55 L180,5 L190,48 L200,12 L210,30 L250,30 L260,52 L270,8 L280,55 L290,5 L300,30 L340,30 L350,8 L360,52 L370,30 L400,30' fill='none' stroke={color} strokeWidth='2.5' animate={{ strokeOpacity: [0.8, 0.4, 0.9, 0.2, 0.7, 0.5, 0.8] }} transition={{ duration: 2, repeat: Infinity }} />
            <motion.line x1='200' y1='30' x2='400' y2='30' stroke={color} strokeWidth='1' strokeDasharray='4 6' animate={{ strokeOpacity: [0.5, 0.1, 0.5] }} transition={{ duration: 1.5, repeat: Infinity }} />
          </>
        )}
      </svg>
      {!stable && (
        <motion.div className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded px-2 py-0.5 text-xs font-bold' style={{ backgroundColor: DANGER_RED, color: '#FFF' }} animate={{ opacity: [1, 0, 1] }} transition={{ duration: 1, repeat: Infinity }}>
          DISCONNECTED
        </motion.div>
      )}
    </div>
  );
}
